// @flow
import { css } from "styled-components";
import { media } from "@nested/brand";
import { Button } from "@nested/component-library";
import { Link } from "react-router-dom";

import { QuestionWrapper } from "..";

export const QuestionNotFound = ({ restartPath }: { restartPath: string }) => (
  <QuestionWrapper data-test="question-not-found-page">
    <p>Sorry, we had a problem with your application, please start again.</p>
    <Link to={restartPath}>
      <Button
        css={css`
          margin-top: 30px;
          ${media.tablet`
            margin-top: 40px;
          `}
        `}
        type="primary"
      >
        Restart application
      </Button>
    </Link>
  </QuestionWrapper>
);
